import { Loadable } from '../../utils/types';
import { TimerStatus } from 'shovel-lib/types';

/**
 *  Redux State Type
 */
export interface TimerState extends Loadable {
  status: TimerStatus;
  startedInUtc: Date | null;
  timePassedInSeconds: number;
  plannedTaskId?: number;
  masterTaskId?: number;
  title?: string;
  // The timed session, as the server describes it (TimerResponse): for the countdown and the top-bar pill.
  plannedMinutes?: number;
  sessionUsedMinutes?: number;
  sessionIsUsed?: boolean;
  reading?: boolean;
}

/** The server's timer with the session details it adds (shovel-lib's TimerDto predates them). */
export type SessionTimerDto = {
  plannedMinutes?: number;
  sessionUsedMinutes?: number;
  sessionIsUsed?: boolean;
  reading?: boolean;
};

export const sessionDetails = (dto?: SessionTimerDto | null) => ({
  plannedMinutes: dto?.plannedMinutes,
  sessionUsedMinutes: dto?.sessionUsedMinutes,
  // Done before this run: ▶ takes a session's tick off (the server says false), so this is also whether its logged
  // time already fills the plan.
  sessionIsUsed:
    !!dto?.sessionIsUsed || (!!dto?.plannedMinutes && (dto?.sessionUsedMinutes || 0) >= (dto?.plannedMinutes || 0)),
  reading: dto?.reading
});
